<template>
  <BaseDialog
    :model-value="modelValue"
    :title="'Cadastrar Licença'"
    :icon="'mdi-certificate'"
    :loading="loading"
    @update:model-value="updateDialog"
    @salvar="salvarLicenca"
    :hide-actions="licencaCriada"
  >
    <v-form v-if="!licencaCriada" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="clienteBuscaLabel"
        label="Cliente"
        :rules="[rules.required]"
        prepend-inner-icon="mdi-account"
        append-inner-icon="mdi-magnify"
        @click:append-inner="abrirDialogBuscaCliente"
        @click="abrirDialogBuscaCliente"
        class="mb-3"
        placeholder="Clique para buscar o cliente"
        readonly
        active
      />
      <v-text-field
        v-model.number="licenca.codplano"
        label="Código do Plano"
        :rules="[rules.required, rules.isNumber]"
        required
        prepend-inner-icon="mdi-file-document-multiple"
        class="mb-3"
        append-inner-icon="mdi-magnify"
        @click:append-inner="abrirBuscaPlano"
      />
      <v-text-field
        v-model="licenca.data_expiracao"
        label="Data de Expiração"
        type="date"
        :rules="[rules.required]"
        required
        prepend-inner-icon="mdi-calendar"
      />
    </v-form>
    <div v-else>
      <v-alert
        type="warning"
        class="mb-4 custom-alert"
        border="start"
        colored-border
        elevation="6"
      >
        <div class="alert-title">
          <span class="alert-title-text">Atenção</span>
        </div>
        <div class="alert-message mt-1">
          Esta licença <b>não ficará visível novamente</b>.<br />
          Copie o código abaixo e guarde em local seguro.
        </div>
        <v-text-field
          v-model="hashParaCopiar"
          label="Licença (hash)"
          readonly
          ref="hashInput"
          :append-inner-icon="copiado ? 'mdi-check' : 'mdi-content-copy'"
          @click:append-inner="copiarHash"
          class="mt-2 hash-field"
        />
      </v-alert>
      <div class="text-center">
        <v-btn
          color="primary"
          block
          class="mt-4"
          @click="fecharDialog"
          :disabled="fecharDesabilitado"
        >
          Fechar<span v-if="fecharDesabilitado">
            ({{ fecharTimeoutRestante }})</span
          >
        </v-btn>
      </div>
    </div>
  </BaseDialog>
  <DialogBusca
    v-model:open="dialogBuscaCliente"
    :rota-busca="'clientes'"
    @selecionado="selecionarCliente"
  />
  <DialogBusca
    :open="dialogBusca"
    rota-busca="planos"
    @update:open="dialogBusca = $event"
    @selecionado="selecionarPlano"
    :exibir-lista="true"
  />
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";
import DialogBusca from "./DialogBusca.vue";
import rulesMixin from "@/mixins/rulesMixin";
import BaseDialog from "./comum/BaseDialog.vue";

export default {
  components: { DialogBusca, BaseDialog },
  mixins: [rulesMixin],
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue", "licenca-cadastrada"],
  data: () => ({
    valid: false,
    loading: false,
    licenca: {
      codcliente: null,
      codplano: null,
      data_expiracao: "",
    },
    licencaCriada: null,
    fecharDesabilitado: false,
    fecharTimeoutRestante: 5,
    fecharInterval: null,
    copiado: false,
    hashParaCopiar: "",
    dialogBuscaCliente: false,
    clienteBuscaLabel: "",
    dialogBusca: false,
    dialogBuscaPlano: false,
    planoBuscaLabel: "",
  }),
  watch: {
    modelValue(val) {
      if (!val) {
        // Limpa o form ao fechar
        this.licenca = { codcliente: null, codplano: null, data_expiracao: "" };
        this.valid = false;
        this.licencaCriada = null;
        this.fecharDesabilitado = false;
        this.fecharTimeoutRestante = 5;
        this.copiado = false;
        this.hashParaCopiar = "";
        this.dialogBuscaCliente = false;
        this.clienteBuscaLabel = "";
        if (this.fecharInterval) {
          clearInterval(this.fecharInterval);
          this.fecharInterval = null;
        }
        if (this.$refs.form) this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    updateDialog(val) {
      this.$emit("update:modelValue", val);
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
    },
    abrirDialogBuscaCliente() {
      this.dialogBuscaCliente = true;
    },
    selecionarCliente(cliente) {
      this.licenca.codcliente = cliente.codcliente;
      this.clienteBuscaLabel = `${cliente.codcliente} - ${cliente.razao_social}`;
    },
    abrirBuscaPlano() {
      this.dialogBusca = true;
    },
    selecionarPlano(plano) {
      this.licenca.codplano = plano.codplano;
    },
    async salvarLicenca() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        const response = await api.post("/licencas/", this.licenca);
        console.log("Resposta da API:", response);
        this.licencaCriada = response.data;
        console.log("Valor de licencaCriada:", this.licencaCriada);
        this.hashParaCopiar = response.data.hash;
        this.iniciarTimeoutFechar();
        this.$emit("licenca-cadastrada");
      } catch (error) {
        console.error("Erro ao salvar licença:", error);
        this.triggerFeedback({
          message: "Erro ao cadastrar licença!",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.loading = false;
    },
    copiarHash() {
      const input = this.$refs.hashInput.$el.querySelector("input");
      input.select();
      input.setSelectionRange(0, 99999);
      try {
        document.execCommand("copy");
        this.copiado = true;
        this.triggerFeedback({
          message: "Licença copiada para área de transferência!",
          color: "success",
          icon: "mdi-check-circle",
        });
        setTimeout(() => {
          this.copiado = false;
        }, 2000);
      } catch (err) {
        this.triggerFeedback({
          message: "Não foi possível copiar a licença automaticamente.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
    iniciarTimeoutFechar() {
      this.fecharDesabilitado = true;
      this.fecharTimeoutRestante = 5;
      if (this.fecharInterval) clearInterval(this.fecharInterval);
      this.fecharInterval = setInterval(() => {
        this.fecharTimeoutRestante--;
        if (this.fecharTimeoutRestante <= 0) {
          this.fecharDesabilitado = false;
          clearInterval(this.fecharInterval);
          this.fecharInterval = null;
        }
      }, 1000);
    },
    apenasNumeros(event) {
      const charCode = event.charCode;
      // Permite apenas números e impede a entrada de caracteres
      if (charCode !== 0 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    console.log('Componente Criado')
  },
};
</script>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}
.hash-field input {
  font-family: "Fira Mono", "Consolas", "Menlo", monospace;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
  color: #1976d2;
  background: #f5fafd;
  border-radius: 6px;
  padding: 6px 10px;
}
.custom-alert {
  background: linear-gradient(90deg, #fffbe7 0%, #fff8e1 100%);
  border-left: 6px solid #ff9800 !important;
  color: #7a4f01 !important;
  padding: 18px 20px 14px 20px !important;
  border-radius: 12px;
  box-shadow: 0 4px 18px 0 rgba(255, 168, 0, 0.08);
  font-size: 1.08rem;
}
.alert-title {
  display: flex;
  align-items: center;
  font-size: 1.22rem;
  font-weight: 700;
  color: #ff9800;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}
.alert-title-text {
  color: #ff9800;
  font-weight: 700;
  text-shadow: 0 1px 0 #fff3e0;
}
.alert-message {
  color: #7a4f01;
  font-size: 1.08rem;
  font-weight: 500;
  letter-spacing: 0.1px;
  margin-left: 30px;
}
</style>
